export default "__VITE_ASSET__DThcWX9D__"